/**
 * 20/10/2026 — what a route test's winner formula and rules may read. On its
 * own drops (source "drops") the samples are the drops' stat bags, which
 * carry SMSWiser's delivery counts next to the tracker's — so a route test
 * can be won on Delivered Rate on a day no visit has come in yet. On the
 * gateway's own stats (source "gateway") only the tracker's formula metrics
 * exist. The engine always scored a bag by key; this is the vocabulary the
 * validators and the editor's picker allow.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FLOW_FORMULA_METRIC_IDS } from "../../formula/catalog";
import { GATE_METRICS } from "../../gate-rules/gate-metrics";
import type { RouteTestSource } from "./route-test";

/** SMSWiser's own numbers (and the ones joining both sets) a drop bag carries. */
export const ROUTE_TEST_SMSWISER_METRIC_IDS: readonly string[] = GATE_METRICS.filter((m) => m.group !== "tracker").map((m) => m.id as string);

/** Everything a route test judged on its drops may name. */
export const ROUTE_TEST_DROP_METRIC_IDS: readonly string[] = [...FLOW_FORMULA_METRIC_IDS, ...ROUTE_TEST_SMSWISER_METRIC_IDS];

/** The metric ids a route test's formula and rules may read, by source. */
export const routeTestMetricIds = (source: RouteTestSource): readonly string[] =>
  source === "drops" ? ROUTE_TEST_DROP_METRIC_IDS : FLOW_FORMULA_METRIC_IDS;
